import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import { Link } from 'react-router-dom';

export default function Signup() {
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const { signup } = useAuth();

  async function handleSubmit(e) {
    e.preventDefault();

    if (password !== passwordConfirm) {
      return setError('Passwords do not match');
    }

    if (password.length < 6) {
      return setError('Password must be at least 6 characters');
    }

    if (username.length < 3) {
      return setError('Username must be at least 3 characters');
    }

    try {
      setMessage('');
      setError('');
      setLoading(true);
      await signup(email, password, username);
      setMessage('Account created successfully! You can now log in.');
    } catch (error) {
      setError('Failed to create an account: ' + error.message);
    }

    setLoading(false);
  }

  return (
    <div className="auth-background">
      <Container 
        className="d-flex align-items-center justify-content-center" 
        style={{ minHeight: "100vh" }}
      >
        <div className="w-100" style={{ maxWidth: "400px" }}>
          <Card className="shadow-lg border-0" style={{ backgroundColor: '#1a1d29', color: '#fff' }}>
            <Card.Body className="p-5">
              <h2 className="text-center mb-4 text-light">
                <span style={{ color: '#4f9eff' }}></span> Trade Central
              </h2>
              <h5 className="text-center mb-4">Sign Up</h5>
              {error && <Alert variant="danger">{error}</Alert>}
              {message && <Alert variant="success">{message}</Alert>}
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    style={{ 
                      backgroundColor: '#2d3343', 
                      border: '1px solid #4f9eff',
                      color: '#fff'
                    }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Username</Form.Label>
                  <Form.Control
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                    placeholder="Choose a unique username"
                    style={{ 
                      backgroundColor: '#2d3343', 
                      border: '1px solid #4f9eff',
                      color: '#fff'
                    }}
                  />
                  <Form.Text className="text-muted">
                    This will be your public profile URL
                  </Form.Text>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    style={{ 
                      backgroundColor: '#2d3343', 
                      border: '1px solid #4f9eff',
                      color: '#fff'
                    }}
                  />
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Password Confirmation</Form.Label>
                  <Form.Control
                    type="password"
                    value={passwordConfirm}
                    onChange={(e) => setPasswordConfirm(e.target.value)}
                    required
                    style={{ 
                      backgroundColor: '#2d3343', 
                      border: '1px solid #4f9eff',
                      color: '#fff'
                    }}
                  />
                </Form.Group>
                <Button 
                  disabled={loading} 
                  className="w-100 mt-3" 
                  type="submit"
                  style={{ 
                    backgroundColor: '#4f9eff', 
                    border: 'none',
                    padding: '12px'
                  }}
                >
                  {loading ? 'Creating Account...' : 'Sign Up'}
                </Button>
              </Form>
              <div className="w-100 text-center mt-3">
                Already have an account? <Link to="/login" style={{ color: '#4f9eff' }}>Log In</Link>
              </div>
            </Card.Body>
          </Card>
        </div>
      </Container>
    </div>
  );
} 